export default __webpack_public_path__ + "media/icons/profile-icon-5e057f83.svg";